<template>
  <div>
    <transition name="el-fade-in">
      <div class="period-of-drop" v-if="subjects.length">
        <el-dropdown :hide-on-click="true" ref="drop" trigger="click" @visible-change="visibleChange">
          <div class="per-s-label flex-center">
            <span v-text="param.periodName"></span>
            <span>-</span>
            <span v-text="param.subjectName"></span>
            <i class="icon-tickets"></i>
          </div>
          <el-dropdown-menu slot="dropdown" class="period-ul-box" :style="style">
            <li
              class="period-box"
              v-for="sub in subjects"
              :key="sub.periodId">
              <p class="peri-title" v-text="sub.name"></p>
              <ul class="clear-fix peri-item-wrap">
                <li
                  class="fl peri-item"
                  :class="{ selected: sub.periodId === param.periodId && li.subjectId === param.subjectId }"
                  @click="check(sub, li)"
                  v-for="li in sub.subjectList"
                  :key="li.subjectId" v-text="li.name"></li>
              </ul>
            </li>
          </el-dropdown-menu>
        </el-dropdown>
        <div v-if="disabled" class="preiod-of-mask"></div>
      </div>
    </transition>
  </div>
</template>

<script>
import apis from '../lib/proxy';
// import subjectStore from '../lib/store';
export default {
  name: 'SubjectSelector',
  data () {
    return {
      subjects: [],
      yxpapiStore: {},
      param: {
        periodId: '', // 学段
        periodName: '', // 学段名
        subjectId: '', // 学科
        subjectName: '', // 学科名
      },
      style: {
        maxHeight: '800px',
      },
    };
  },
  props: {
    period_subject_name: {
      type: Object,
    },
    periodIds: {
      type: Array,
      default: () => [],
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    defaultSelected: {
      type: Object, // periodId,subjectId
    },
    defaultPeriod: { // 默认学段
      type: [Number, String],
      default: 4,
    },
  },
  mounted () {
    // 由于修改学科后，需要重新请求接口，所以不能存vuex里
    // this.registerModule();
    // let data = this.yxpapiStore.getters['subjectSelector/subjectData'];
    // if (data.hasOwnProperty('errcode') && data.errcode === 0) {
    //   this.initData(data);
    // } else {
    //   this.requestData();
    // }
    this.requestData();
  },
  methods: {
    // 注册vuex模块
    // 由于修改学科后，需要重新请求接口，所以不能存vuex里
    // registerModule () {
    //   this.yxpapiStore = window.yxpapi.store;
    //   if (this.yxpapiStore && !this.yxpapiStore._modules.root._children['subjectSelector']) {
    //     this.yxpapiStore.registerModule(['subjectSelector'], subjectStore);
    //   }
    // },
    // 请求数据
    requestData () {
      apis.getAllSubject().then(data => {
        this.initData(data);
        // 由于修改学科后，需要重新请求接口，所以不能存vuex里
        // this.yxpapiStore.commit('subjectSelector/setSubjectData', data);
      }, j => { console.log(j); });
    },
    // 初始化数据
    initData (data) {
      if (data.errcode === 0) {
        let cache = JSON.parse(sessionStorage.getItem('period-study'));
        this.subjects = [];
        let list = data.data;
        if (!this.periodIds || this.periodIds.length === 0) {
          this.subjects = list;
        } else {
          for (let item of list) {
            if (this.periodIds.indexOf(item.periodId) > -1) {
              this.subjects.push(item);
            }
          }
        }
        // 如果有默认选择的学段学科
        if (this.defaultSelected) {
          for (let period of this.subjects) {
            if (period.periodId === this.defaultSelected.periodId) {
              for (let subject of period.subjectList) {
                if (subject.subjectId === this.defaultSelected.subjectId) {
                  Object.assign(this.param, {
                    periodId: period.periodId,
                    periodName: period.name,
                  }, {
                    subjectId: subject.subjectId,
                    subjectName: subject.name,
                  });
                  break;
                }
              }
              break;
            }
          }
        } else {
          if (cache && this.subjects.some(({ periodId, subjectList }) => {
            return periodId === cache.periodId && subjectList.some(({ subjectId }) => subjectId === cache.subjectId);
          })) {
            Object.assign(this.param, cache);
          } else {
            Object.assign(this.param, this.getSubject());
          }
        }
        if (this.period_subject_name) {
          this.param.periodName = this.period_subject_name.periodName;
          this.param.subjectName = this.period_subject_name.subjectName;
        }
        this.$emit('checked', Object.assign({}, this.param));
      } else {
        // this.$message.error(data.errmsg);
        console.log(data.errmsg);
      }
    },
    getSubject () {
      let period = {
        periodId: '', // 学段
        name: '', // 学段名
      };
      let subject = {
        subjectId: '', // 学科
        name: '', // 学科名
      };
      const option = this.subjects.find(item => Number(item.periodId) === Number(this.defaultPeriod) && item.subjectList.length);
      if (option) {
        period = option;
        subject = option.subjectList[0];
      } else {
        this.subjects.some(itm => {
          if (itm.subjectList.length > 0) {
            period = itm;
            subject = itm.subjectList[0];
            return true;
          }
        });
      }

      return {
        periodId: period.periodId, // 学段
        periodName: period.name, // 学段名
        subjectId: subject.subjectId, // 学科
        subjectName: subject.name, // 学科名
      };
    },
    visibleChange (v) {
      if (v) {
        this.style.maxHeight = document.documentElement.clientHeight - 150 + 'px';
      }
    },
    check (period, subject) {
      Object.assign(this.param, {
        periodId: period.periodId, // 学段
        periodName: period.name, // 学段名
        subjectId: subject.subjectId, // 学科
        subjectName: subject.name, // 学科名
      });
      this.$refs.drop.hide();
      sessionStorage.setItem('period-study', JSON.stringify(this.param));
      this.$emit('checked', Object.assign({}, this.param));
    },
  },
};
</script>

<style scoped lang="scss">
  @import "./sass/theme.scss";
  .period-of-drop {
    position: relative;
  }
  .icon-tickets {
    font-size: 25px;
    width: 40px;
    display: inline-block;
    background: url("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABEAAAAOCAYAAADJ7fe0AAAAAXNSR0IArs4c6QAAACJJREFUKBVj/A8EDBQCJgr1j2rHEQKMo7GDI2QGg/DgiR0Av0UL/pWSRFsAAAAASUVORK5CYII=") no-repeat center center;
  }
  .per-s-label {
    background: $primary;
    height: 36px;
    width: 260px;
    line-height: 36px;
    border-top-left-radius: 5px;
    border-top-right-radius: 5px;
    color: #fff;
    padding: 0 30px;
    cursor: pointer;
    text-align: center;
  }
  .period-box {
    border-bottom: 1px solid $primary;
    padding: 15px 0 5px;
    &:last-of-type {
      border-bottom-color: transparent;
    }
  }
  .clear-fix {
    &:before, &:after {
      content: '';
      display: block;
    }
    &:after {
      clear: both;
    }
  }
  .fl {
    float: left;
  }
  .fr {
    float: right;
  }
  .preiod-of-mask {
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    left: 0;
    z-index: 10;
    cursor: not-allowed;
  }
  .flex-center {
    display: flex;
    justify-content: center;
  }
</style>
<style lang="scss">
  @import "./sass/theme.scss";
  .period-ul-box.el-dropdown-menu.el-popper {
    width: 260px;
    margin-top: 0;
    background: #F8FFFB;
    border: 1px solid $primary {
      top-color: transparent;
    };
    line-height: 25px;
    border-top-right-radius: 0;
    border-top-left-radius: 0;
    padding: 15px;
    overflow-y: auto;
    .popper__arrow {
      display: none;
    }
    .peri-title {
      color: $primary;
      padding: 0 14px;
      margin-bottom: 10px;
      font-size: 14px;
    }
    .peri-item-wrap {
      margin: 0 -15px 0 0;
    }
    .peri-item {
      padding: 0 14px;
      margin: 0 15px 10px 0;
      cursor: pointer;
      font-size: 14px;
      &.selected {
        background: $primary;
        color: #fff;
      }
    }
  }
</style>
